// @flow
import * as React from 'react';
import PercentInput from 'components/PercentInput';
import Field from './Field';

const PercentInputField = ({
  name,
  label,
  description,
  mapError,
  ...props
}: {
  name: string,
  label?: string,
  description?: string,
  mapError?: string => React.Node
}) => (
  <Field
    inputProps={props}
    name={name}
    label={label}
    description={description}
    mapError={mapError}
    renderInput={({ value, id, qaId, hasError, updateValue }) => (
      <PercentInput
        id={id}
        name={name}
        value={value || ''}
        hasError={hasError}
        data-qa-id={qaId}
        onChange={e => {
          updateValue(e.target.value);
        }}
        {...props}
      />
    )}
  />
);

export default PercentInputField;
